import { onLoad } from "@otto-ec/global-resources/dom";
import type { AsyncNamespaceInput, NexusHandler } from "@otto-ec/global-resources/nexus";
import { toggle } from "@otto-ec/global-resources/toggle";
import type BackToTopButtonV1 from "./BackToTopButtonV1.async.svelte";
import { selector } from "./config";

let backToTopButton: HTMLElement | null = null;
let isScrollActivationDisabled = false;

export const disableScrollActivation = function disableScrollActivation() {
  backToTopButton?.remove();
  isScrollActivationDisabled = true;
} satisfies NexusHandler<BackToTopButtonV1["disableScrollActivation"]>;

/*                                                                               */
export const backToTopButtonV1: AsyncNamespaceInput<OttoComponentApi["backToTopButtonV1"]> = {
  disableScrollActivation,
};

onLoad.subscribe(() => {
  if (
    isScrollActivationDisabled ||
    !toggle.get("oc_back_to_top_button_enabled", true) ||
    !document.querySelector(selector) /*                        */
  ) {
    return;
  }

  backToTopButton = document.createElement("oc-back-to-top-button-v1");
  document.body.appendChild(backToTopButton);
});
